import createReactComponent from '../createReactComponent';
export default createReactComponent('caret-up-down', 'IconCaretUpDown', [
  ['path', { d: 'M18 10l-6 -6l-6 6h12', key: 'svg-0' }],
  ['path', { d: 'M18 14l-6 6l-6 -6h12', key: 'svg-1' }],
]);
